import store from "store";
import { apiClient, occmClient, forwarderClient, downloadCSVClient } from "./clients";
import { utils as i18nNamespace } from "../../src/i18n/namespace";
import { getLocalizedValue as t } from "../../src/i18n";
import { IS_PRODUCTION_SAAS_UI, IS_DEV_SAAS_UI } from "./app/utils";


// In non-production environments, there might be certain URLs that we want to bypass the 401 interceptor
// We can maintain a list of such URLs and check against it in the interceptor.
//Ex. if an API only has staging and prod versions - and we are using the staging version in dev, then we might get a 401
const urlIdentifiersToBypass401Handling = []; // only for non-prod envs
let isProcessing401 = false;

const shouldBypassUrlFor401ResponseHandling = (url) => {
    if (IS_PRODUCTION_SAAS_UI || urlIdentifiersToBypass401Handling.length === 0 || !url) {
        return false;
    }
    return urlIdentifiersToBypass401Handling.some((bypassUrl) => url.includes(bypassUrl));
}

const handle401 = (url) => {
    //TODO: remove Console-Dev from here after identifying URLs that need to be bypassed in dev environment
    if (shouldBypassUrlFor401ResponseHandling(url) || IS_DEV_SAAS_UI) {
        console.warn(`Bypassing 401 interceptor for URL: ${url}`);
        return;
    }

    if (isProcessing401) return;
    isProcessing401 = true;

    //safety check to prevent infinite reload loops - only reload once per sessionStorage key
    const reloadCount = Number(sessionStorage.getItem('401_reload_count') || 0);
    if (reloadCount >= 1) {
        sessionStorage.removeItem('401_reload_count');
        console.error("Received repeated 401 responses, not reloading again.");
        return;
    }
    //show error and reload
    console.error("Received 401 response, reloading to receive new auth token...");
    store.dispatch({
        type: "NOTIFICATIONS:ERROR",
        payload: {
            message: t("session_expired_err_message", i18nNamespace)
        }
    });
    sessionStorage.setItem('401_reload_count', String(reloadCount + 1));
    setTimeout(() => window.location.reload(), 2000);
};

const setupResponseInterceptor = (client) => {
    client.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error?.response?.status === 401) {
                handle401(error?.response?.config?.url);
            }
            return Promise.reject(error);
        }
    );
};

const initializeResponseInterceptors = () => {
    setupResponseInterceptor(apiClient);
    setupResponseInterceptor(occmClient);
    setupResponseInterceptor(forwarderClient);
    setupResponseInterceptor(downloadCSVClient);
};

export const initializeClientInterceptors = () => {
    initializeResponseInterceptors();
};
